import blog19Main from "@/assets/images/blogs/19/main-kid.png";
import blog19_2 from "@/assets/images/blogs/19/image3.png";
import blog19_3 from "@/assets/images/blogs/19/kid-refridge.png";
import { BLOG_TAGS } from "../BlogTags";
import BlogContent, { BlogContentWithSlug } from "../BlogContent";
import { addSlug } from "@/utils/addSlug";
import ROUTES from "@/data/Routes";
import { ActionLink } from "@/components/UI/Buttons";

const KIDS_GENETICS_WITHOUT_SLUG: BlogContent = {
  id: 19,
  label:
    "Sąmoningas vaiko ugdymas: kai mokslinės įžvalgos tampa šeimos harmonija",
  description:
    "Daugelis tėvų susiduria su iššūkiu diegiant sveikus įpročius: kaip žinoti, kurie pokyčiai vaikui yra kritiškai svarbūs, o kurie - tik bendro pobūdžio rekomendacijos? Dažnai pasipriešinimas naujovėms kyla ne dėl vaiko būdo, o dėl to, kad siūlomi pokyčiai neatitinka jo individualaus ritmo ar poreikių.",
  descriptionInner:
    "Daugelis tėvų susiduria su iššūkiu diegiant sveikus įpročius: kaip žinoti, kurie pokyčiai vaikui yra kritiškai svarbūs, o kurie - tik bendro pobūdžio rekomendacijos? Dažnai pasipriešinimas naujovėms kyla ne dėl vaiko būdo, o dėl to, kad siūlomi pokyčiai neatitinka jo individualaus ritmo ar poreikių.",
  img_src: blog19Main,
  alt: "Vaikų genetika",
  tags: [BLOG_TAGS.GENETICS.label],
  innerData: [
    {
      id: 1,
      label: "",
      description: [
        "Telomeros klinikoje mes tikime, kad efektyviausias kelias į vaiko sveikatą prasideda nuo tikslių duomenų. Norint sukurti tvirtą sveikatos pamatą, neužtenka vien intuicijos - reikia matyti visumą: nuo to, kas įrašyta vaiko DNR, iki to, kas vyksta jo organizme čia ir dabar.",
      ],
    },
    {
      id: 2,
      label: "Kompleksinis požiūris: organizmo būsena iš dviejų perspektyvų",
      img_src: blog19_2,
      img_mob_src: blog19_2,
      description: [
        "Mūsų vaikų sveikatos programa sukurta taip, kad apimtų viską, ko reikia giliam vaiko organizmo pažinimui. Tai nėra tik vienas tyrimas - tai visapusiška diagnostika. Kiekvienas tyrimas parenkamas pagal kiekvieną vaiką individualiai, priklausomai nuo amžiaus, jau atliktų tyrimų bei lūkesčių.",
        <b>1. DNR tyrimas: vaiko prigimties žemėlapis</b>,
        "Išsamus DNR testas apima net 15 sveikatos sričių. Mes analizuojame mitybos ypatumus, streso valdymą, miego kokybę, sportinį potencialą, regėjimą, kognityvinius gabumus bei polinkį į traumas. Tai leidžia suprasti vaiko biologines stiprybes ir sritis, kurioms reikės didesnio dėmesio ateityje.",
        <b>2. Platūs kraujo tyrimai: esamos būklės diagnostika</b>,
        "Genetika parodo polinkius, o kraujo tyrimai - realią situaciją šią akimirką. Programos metu vertinama:",
        " •	Mikroelementų ir vitaminų balansas bei baltymų apykaita.",
        " •	Gyvybiškai svarbios funkcijos: kepenų, inkstų, kasos bei gliukozės apykaita.",
        " •	Sisteminė sveikata: širdies ir kraujagyslių sistema, hormonų pusiausvyra bei imunitetas.",
      ],
    },
    {
      id: 3,
      label: "Komandinis darbas ir personalizuotas planas",
      img_src: blog19_3,
      img_mob_src: blog19_3,
      description: [
        "Surinkti duomenys nėra tiesiog dar viena medicininė ataskaita. Juos analizuoja ir tėvams pristato aukščiausios kvalifikacijos komanda: genetikas, šeimos gydytojas ir sveikos gyvensenos specialistas.",
        "Būtent šios konsultacijos metu pristatomas unikalus žaidybinis planas, sukurtas remiantis tyrimų rezultatais. Mes žinome, kad vaikams „gera savijauta ateityje“ nėra motyvas, todėl sveikus įpročius paverčiame įtraukiančiomis misijomis, pavyzdžiui:",
        " •	Misija „Ramus protas“: mokomės valdyti stresą ir rasti laiko kokybiškam poilsiui.",
        " •	Misija „Kuras kūnui“: suprantame, kokių medžiagų reikia smegenims ir raumenims, rinkdami specialius taškus už pasirinktą maistą.",
        "Tai leidžia vaikui naujus įpročius priimti ne kaip prievolę, o kaip smagų nuotykį, kuriame dalyvauja visa šeima. Kiekvienam vaikui žaidybinis planas sukuriamas individualiai, pagal jo pomėgius ir pagal tai, kas jam aktualu šiuo metu.",
      ],
    },
    {
      id: 4,
      label: "Investicija į vaiko ateitį",
      description: [
        "Kuo anksčiau įdiegsite individualiai pagrįstus įpročius, tuo tvaresnį pamatą sukursite vaiko sveikatai. Tai galimybė išvengti ateities sveikatos problemų, kurias suaugus išspręsti būna kur kas sunkiau.",
        "Kviečiame pasirinkti jūsų šeimai tinkamiausią pažinimo gylį.",
        "Jau turite atliktus tam tikrus tyrimus? Susisiekite ar registruokitės nemokamai konsultacijai, parinksime tyrimų ir konsultacijų planą pagal jūsų individualią situaciją ir galimybes.",
        "Leiskite mokslui tapti jūsų šeimos sąjungininku. Sužinokite, kaip auginti vaiką harmonijoje su jo prigimtimi ir esama sveikatos būkle.",
      ],
    },
    {
      id: 5,
      labelClass: "text-center",
      label: "Kyla klausimų? Registruokitės konsultacijai",
      description: [
        <div className="mt-4 flex justify-center">
          <ActionLink
            to={ROUTES.CONSULTATION}
            variant="dark"
            className="hidden w-full md:flex md:w-auto"
          >
            Registruotis
          </ActionLink>
        </div>,
      ],
    },
  ],
};

export const KIDS_GENETICS: BlogContentWithSlug = addSlug(
  KIDS_GENETICS_WITHOUT_SLUG,
);

export default KIDS_GENETICS;
